import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { ArchidriveShareComponent } from './archidrive-share';

export const ArchidriveShareModule: string = ng
    .module('archidrive-share', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('archidriveShareComponent', ArchidriveShareComponent)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/home/archidrive/archidrive-share/archidrive-share.module.ts